import React, { useEffect, useContext, useState } from 'react';
import { shape } from 'prop-types';
import { ReservationContext } from '../../context/reservation-context';
import { EXACT_MATCH_LABEL, CLOSEST_MATCH_LABEL, UNAVAILABLE_MATCH_LABEL } from '../../constants/messages';
import helper from '../../utils/helper';

import './availability-tag.scss';

const TAG_TYPE_EXACT_MATCH = 'Exact';
const TAG_TYPE_CLOSEST_MATCH = 'Close';
const TAG_TYPE_UNAVAILABLE = 'Unavailable';

const ExactMatchTag = () => {
  return (<div className="exact-match" data-testid="exact-match">{EXACT_MATCH_LABEL}</div>);
};
const ClosestMatchTag = () => {
  return (<div className="closest-match" data-testid="closest-match">{CLOSEST_MATCH_LABEL}</div>);
};
const UnavailableMatchTag = () => {
  return (<div className="unavailable-match" data-testid="unavailable-match">{UNAVAILABLE_MATCH_LABEL}</div>);
};

export const AvailabilityTag = ({ store }) => {
  const [tagType, setTagType] = useState();
  const [{ reservation }] = useContext(ReservationContext);

  useEffect(() => {
    if (!store?.availableHours?.length > 0) {
      setTagType(TAG_TYPE_UNAVAILABLE);
    } else if (helper.checkExactAvailability({ store, reservation })) {
      setTagType(TAG_TYPE_EXACT_MATCH);
    } else {
      setTagType(TAG_TYPE_CLOSEST_MATCH);
    }
  }, []);

  if (tagType === TAG_TYPE_EXACT_MATCH) {
    return <ExactMatchTag />;
  }

  if (tagType === TAG_TYPE_CLOSEST_MATCH) {
    return <ClosestMatchTag />;
  }

  if (tagType === TAG_TYPE_UNAVAILABLE) {
    return <UnavailableMatchTag />;
  }

  return null;

};

AvailabilityTag.propTypes = {
  store: shape({}).isRequired
};
